import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "order-details",
  class: "bg-white min-w-full w-full z-20 overflow-auto bg-white rounded mb-5"
}
const _hoisted_2 = { class: "w-full flex items-center gap-2" }
const _hoisted_3 = { class: "text-lg text-left min-w-[100px]" }
const _hoisted_4 = { class: "w-full flex items-center gap-2" }
const _hoisted_5 = { class: "text-lg text-left w-[100px] min-w-[100px]" }
const _hoisted_6 = { class: "w-full flex items-center gap-2" }
const _hoisted_7 = { class: "text-lg text-left w-[100px] min-w-[100px]" }
const _hoisted_8 = { class: "w-full flex items-center gap-2" }
const _hoisted_9 = { class: "text-lg text-left w-[100px] min-w-[100px]" }
const _hoisted_10 = { class: "flex flex-col gap-1 p-2 mx-2 border-b" }
const _hoisted_11 = { class: "w-full flex items-center gap-2" }
const _hoisted_12 = { class: "text-lg text-left w-[140px] min-w-[140px]" }
const _hoisted_13 = { class: "w-full flex items-center gap-2" }
const _hoisted_14 = { class: "text-lg text-left w-[140px] min-w-[140px]" }
const _hoisted_15 = { class: "w-full flex items-center gap-2" }
const _hoisted_16 = { class: "text-lg text-left w-[140px] min-w-[140px]" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-col pt-4 pb-2"
}
const _hoisted_18 = { class: "text-red-500 pr-2" }
const _hoisted_19 = { class: "flex flex-col gap-6 p-2 mx-2" }
const _hoisted_20 = { class: "w-full flex justify-between items-center gap-6" }
const _hoisted_21 = { class: "w-full flex justify-between items-center gap-6" }
const _hoisted_22 = {
  key: 1,
  class: "min-h-screen flex items-center justify-center bg-gray-100"
}
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "text-gray-700" }

import store from "@/store";
import {
  weightRegex,
  heightCodeRegex,
  loadingUnitRegex,
  licensePlateRegex,
  containerTypeRegex,
  CARRIER_BOOKED_ORDER,
  LOADED_AT_SENDER,
  DIRECTION_DELIVERY,
  COUNTER_CANCELLATION_NEEDED,
} from "@/utils/constants";
import { populateParams } from "@/utils/methods";

import DbInput from "@/components/DB-Components/DbInput.vue";
import OrderContainerTypeInput from "./OrderContainerTypeInput.vue";
import OrderHeightInput from "./OrderHeightInput.vue";
import OrderWeightInput from "./OrderWeightInput.vue";
import { ref, reactive, computed, onMounted, onBeforeUnmount } from "vue";
import { DbButton } from "@db-ui/v-elements-enterprise/dist/components";
import StatusChangeButton from "@/components/StatusChangeButton.vue";
import DiscardOrderButton from "@/components/DiscardOrderButton.vue";
import { i18n } from "@/i18n/i18n";
import _ from "lodash";
interface FormValidation {
  loading_unit_formatted: string;
  type: string;
  heightCode: string;
  loadWeight: string;
  emptyWeight: string;
  licensePlate: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderDetails',
  props: {
  order: {
    type: Object,
    default: () => ({
      orderId: null,
      orderPosition: null,
      primaryReference: null,
      secondaryReference: null,
      directionType: null,
      transportationStatus: null,
      loading_unit_formatted: null,
      loadUnit: {
        identifierPrefix: null,
        identifierNumber: null,
        type: null,
        lengthCode: null,
        heightCode: null,
        emptyWeight: null,
        loadWeight: null,
        totalWeight: null,
        loadingStatus: null,
        dangerousGoods: false, // Set default value for boolean properties
        waste: false,
        limitedQuantity: false,
        customsGoods: false,
      },
      train: {
        trainNumber: null,
        operatorId: null,
        operatorName: null,
        shippingDate: null,
        trainClosingTime: null,
        trainArrivalTime: null,
        trainState: null,
      },
      terminal: {
        terminalId: {
          locationCode: null,
          authority: null,
        },
        terminalName: null,
      },
      freightForwarderId: null,
      freightForwarderName: null,
      licensePlate: null,
      driverId: null,
    }),
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  index: Number,
},
  emits: ["close", "refreshData"],
  setup(__props, { emit: __emit }) {

const { t } = i18n.global;
const emit = __emit;

const props = __props;

const originalItem = ref(_.cloneDeep(props.order));
const orderItem = ref(_.cloneDeep(props.order));
const loadUnit = ref(props.order.loadUnit);

const params = computed(() => {
  return populateParams(orderItem.value, checkIfDisabled());
});

let formValidations = reactive({
  loading_unit_formatted: { invalid: "false", rx: loadingUnitRegex },
  type: { invalid: "false", rx: containerTypeRegex },
  heightCode: { invalid: "false", rx: heightCodeRegex },
  loadWeight: { invalid: "false", rx: weightRegex },
  emptyWeight: { invalid: "false", rx: weightRegex },
  licensePlate: { invalid: "false", rx: licensePlateRegex },
});

const validateInput = (
  input: string,
  rx: RegExp,
  formValidationsKey: keyof FormValidation
) => {
  if (input !== null && typeof input !== "undefined") {
    formValidations[formValidationsKey].invalid = `${!rx.test(input)}`;
  } else {
    formValidations[formValidationsKey].invalid = "true";
    if (formValidationsKey === "loading_unit_formatted") {
      // empty string is okay for these keys
      formValidations[formValidationsKey].invalid = "false";
    }
  }
  formValidations = { ...formValidations };
};

const showError = (formValidationsKey: keyof FormValidation) => {
  let errorType = "Save";
  if (formValidationsKey === "licensePlate") {
    errorType = "LicensePlate";
  }
  return formValidations[formValidationsKey].invalid === "true"
    ? t(`order.error${errorType}`)
    : undefined;
};

const allFieldsValidated = () => {
  const formValidationsSliced = Object.keys(formValidations);
  formValidationsSliced.pop(); // remove license plate from validation
  return formValidationsSliced.every(
    (key) =>
      formValidations[key as keyof typeof formValidations].invalid === "false"
  );
};

onMounted(() => {
  const formValidationKeys: (keyof FormValidation)[] = [
    "loading_unit_formatted",
    "licensePlate",
  ];
  formValidationKeys.forEach((key) =>
    validateInput(orderItem.value[key], formValidations[key].rx, key)
  );
  const nestedFormValidationKeys: (keyof FormValidation)[] = [
    "type",
    "heightCode",
    "loadWeight",
    "emptyWeight",
  ];
  nestedFormValidationKeys.forEach((key) =>
    validateInput(loadUnit.value[key], formValidations[key].rx, key)
  );
});

const save = async () => {
  await store.dispatch("toggleLoading", true);
  let params = populateParams(orderItem.value, checkIfDisabled());
  try {
    await store.dispatch("OrderStore/updateOrder", {
      order: orderItem.value,
      index: props.index,
      params: params,
    });
    emit("close");
    await store.dispatch("toggleLoading", false);
  } catch (error) {
    await store.dispatch("toggleLoading", false);
    if (error.message.includes("parallel")) {
      store.dispatch("ErrorModalStore/toggleErrorModal", {
        errorType: "parallelEditError",
      });
    }
  }
};

const close = () => {
  emit("close");
};

const licensePlateInvalid = () => {
  if (!store.state.user.data.license_plate) return true;
  return !licensePlateRegex.test(store.state.user.data.license_plate);
};

const checkIfDisabled = (input = "") => {
  if (props.readonly) return true;

  if (orderItem.value?.directionType?.toLowerCase() == DIRECTION_DELIVERY) {
    if (
      orderItem.value?.transportationStatus === CARRIER_BOOKED_ORDER ||
      orderItem.value?.transportationStatus === LOADED_AT_SENDER
    ) {
      return false;
    }
  } else {
    if (input === "licensePlate") {
      return false;
    }
  }
  return true;
};

onBeforeUnmount(() => {
  orderItem.value = originalItem.value;
});

return (_ctx: any,_cache: any) => {
  return (orderItem.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass([{
        'pointer-events-none opacity-50':
          orderItem.value.transportationStatus === _unref(COUNTER_CANCELLATION_NEEDED),
      }, "flex flex-col gap-1 p-2 mx-2 border-b"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("order.loading_unit")) + ":", 1),
            _createVNode(DbInput, {
              disabled: checkIfDisabled(),
              modelValue: orderItem.value.loading_unit_formatted,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((orderItem.value.loading_unit_formatted) = $event)),
                _cache[1] || (_cache[1] = 
            () =>
              validateInput(
                orderItem.value.loading_unit_formatted,
                _unref(loadingUnitRegex),
                'loading_unit_formatted'
              )
          )
              ],
              value: orderItem.value.loading_unit_formatted,
              class: "w-full hydrated",
              ariainvalid: _unref(formValidations)['loading_unit_formatted'].invalid,
              "error-message": showError('loading_unit_formatted')
            }, null, 8, ["disabled", "modelValue", "value", "ariainvalid", "error-message"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("order.unit_type")) + ":", 1),
            _createVNode(OrderContainerTypeInput, {
              disabled: checkIfDisabled(),
              modelValue: orderItem.value.loadUnit.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((orderItem.value.loadUnit.type) = $event)),
              value: orderItem.value.loadUnit.type,
              lengthRestriction: orderItem.value.loadUnit.lengthCode,
              class: "w-full hydrated",
              ariainvalid: 
            _unref(formValidations)['type'].invalid === 'true' ? true : false
          ,
              onChange: _cache[3] || (_cache[3] = 
            () =>
              validateInput(orderItem.value.loadUnit.type, _unref(containerTypeRegex), 'type')
          ),
              "error-message": showError('type')
            }, null, 8, ["disabled", "modelValue", "value", "lengthRestriction", "ariainvalid", "error-message"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("order.length")) + ":", 1),
            _createVNode(DbInput, {
              modelValue: orderItem.value.loadUnit.lengthCode,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((orderItem.value.loadUnit.lengthCode) = $event)),
              value: orderItem.value.loadUnit.lengthCode,
              disabled: "",
              class: "w-full hydrated"
            }, null, 8, ["modelValue", "value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("order.height")) + ":", 1),
            _createVNode(OrderHeightInput, {
              modelValue: orderItem.value.loadUnit.heightCode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((orderItem.value.loadUnit.heightCode) = $event)),
              disabled: checkIfDisabled(),
              ariainvalid: 
            _unref(formValidations)['heightCode'].invalid === 'true' ? true : false
          ,
              onChange: _cache[6] || (_cache[6] = 
            () =>
              validateInput(
                orderItem.value.loadUnit.heightCode,
                _unref(heightCodeRegex),
                'heightCode'
              )
          ),
              "error-message": showError('heightCode')
            }, null, 8, ["modelValue", "disabled", "ariainvalid", "error-message"])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("order.load_weight")) + ":", 1),
            _createVNode(OrderWeightInput, {
              placeholder: "1.000 kg",
              modelValue: orderItem.value.loadUnit.loadWeight,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((orderItem.value.loadUnit.loadWeight) = $event)),
                _cache[8] || (_cache[8] = 
            () =>
              validateInput(
                `${orderItem.value.loadUnit.loadWeight}`,
                _unref(weightRegex),
                'loadWeight'
              )
          )
              ],
              value: orderItem.value.loadUnit.loadWeight,
              disabled: checkIfDisabled(),
              ariainvalid: _unref(formValidations)['loadWeight'].invalid,
              "error-message": showError('loadWeight')
            }, null, 8, ["modelValue", "value", "disabled", "ariainvalid", "error-message"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("order.net_weight")) + ":", 1),
            _createVNode(OrderWeightInput, {
              placeholder: "4.000 kg",
              modelValue: orderItem.value.loadUnit.emptyWeight,
              "onUpdate:modelValue": [
                _cache[9] || (_cache[9] = ($event: any) => ((orderItem.value.loadUnit.emptyWeight) = $event)),
                _cache[10] || (_cache[10] = 
            () =>
              validateInput(
                `${orderItem.value.loadUnit.emptyWeight}`,
                _unref(weightRegex),
                'emptyWeight'
              )
          )
              ],
              value: orderItem.value.loadUnit.emptyWeight,
              disabled: checkIfDisabled(),
              ariainvalid: _unref(formValidations)['emptyWeight'].invalid,
              "error-message": showError('emptyWeight')
            }, null, 8, ["modelValue", "value", "disabled", "ariainvalid", "error-message"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("order.total_weight")) + ":", 1),
            _createVNode(OrderWeightInput, {
              placeholder: "4.000 kg",
              modelValue: orderItem.value.loadUnit.totalWeight,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((orderItem.value.loadUnit.totalWeight) = $event)),
              value: orderItem.value.loadUnit.totalWeight,
              disabled: true
            }, null, 8, ["modelValue", "value"])
          ])
        ]),
        (licensePlateInvalid())
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("order.add_license_plate")), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_unref(DbButton), {
              onClick: close,
              class: "w-full hydrated",
              variant: "secondary-solid"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("order.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(DbButton), {
              onClick: save,
              class: "w-full hydrated",
              variant: "primary",
              disabled: !allFieldsValidated()
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("order.save")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(DiscardOrderButton, {
              order: __props.order,
              index: __props.index,
              onClose: close,
              onRefreshData: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('refreshData')))
            }, null, 8, ["order", "index"]),
            (orderItem.value)
              ? (_openBlock(), _createBlock(StatusChangeButton, {
                  key: 0,
                  order: __props.order,
                  index: __props.index,
                  disabled: licensePlateInvalid(),
                  onClose: close,
                  editedOrder: orderItem.value,
                  params: params.value
                }, null, 8, ["order", "index", "disabled", "editedOrder", "params"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "text-4xl font-bold mb-4" }, "404", -1)),
          _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("order.pageNotFound")), 1)
        ])
      ]))
}
}

})